import React, { useState, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import { styled } from "@mui/material/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, InputAdornment, Popover, TableSortLabel, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import TakeActionItem from "../../../../../templates/Forms/TakeActionItem";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import { useTranslation } from "react-i18next";
import Summary from "../../citizen/TCPForms/formComponents/purchasableFAR/Summary";
import { Loader } from "@egovernments/digit-ui-react-components";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { convertEpochToDate, convertEpochToDateDMY } from "../../../utils";
import SearchSummary from "../../citizen/AVPForms/formComponents/map-submission/Summary/SearchSummary";
// import SearchIcon from "@mui/icons-material/Search";
import { ArrowDownward, PresentToAll } from "@mui/icons-material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FaFileExcel } from "react-icons/fa";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableHeader: {
    backgroundColor: "#225785",
    borderBottom: "2px solid #ddd",
  },
  tableCell: {
    textAlign: "center",
    padding: "10px 15px",
    fontWeight: "bold",
    borderRight: "1px solid #ddd",
  },
  lastTableCell: {
    borderRight: "none",
  },
  whiteText: {
    color: "#ffffff",
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  backgroundColor: "#1f4a7c",
  color: theme.palette.common.white,
  "& .MuiTableSortLabel-root": {
    color: "white",
    "&:hover": {
      color: "white",
    },
    "&.Mui-active": {
      color: "white",
    },
  },
  "& .MuiInput-root": {
    "&:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.42)",
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: "white",
    },
    "&:after": {
      borderBottomColor: "white",
    },
    "& input": {
      color: "white",
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.7)",
      },
    },
  },
  "& .MuiSvgIcon-root": {
    color: "white",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const matchesSearch = (value, search) => {
  if (!value) return false;
  return value.toString().toLowerCase().includes(search.toLowerCase());
};

const InboxTable = ({ ApplicationData, isLoading }) => {
  console.log("applicationdata", ApplicationData, ApplicationData?.[0]?.additionalDetails?.landInfo?.owners?.[0]?.name);

  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [smShow, setSmShow] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [SmShowFAR, setSmShowFAR] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const handleTakeAction = (item) => {
    console.log("itemFromTakeAction", item, item?.businessService);
    switch (item?.businessService) {
      case "BPAREG":
        history.push(`/digit-ui/employee/obps/professional/${item?.applicationNo}`);
        break;
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationNo}`);
        // handleClose();
        break;
      case "BPA_FAR_DA":
      case "BPA_FAR_AVP":
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item?.applicationNo}`);
        // handleClose();
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item?.applicationNo}`);
        // handleClose();
        break;
      case "BPA_PURCHASEFAR_DA":
      case "BPA_PURCHASEFAR_AVP":
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationNo}`);
        break;
      case "BPA_MAPPLINTH_DA":
        // Digit.SessionStorage.del("EMP_MAPSUB");
        // Digit?.SessionStorage.del("isDocValidated");
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationNo}`);
        break;
    }
    // setAnchorEl(false);
  };
  const getProposedActivity = (item) =>
    item?.businessObject?.activityProposed ||
    item?.businessObject?.additionalDetails?.activityProposed ||
    item?.businessObject?.additionalDetails?.descriptionOfLand?.activityProposed ||
    item?.businessObject?.descriptionOfLand?.activityProposed ||
    item?.activityProposed ||
    item?.additionalDetails?.activityProposed ||
    item?.additionalDetails?.descriptionOfLand?.activityProposed ||
    item?.descriptionOfLand?.activityProposed ||
    "-";
  const getPlotArea = (item) =>
    item?.businessObject?.plotArea ||
    item?.businessObject?.plotInfo?.plotArea ||
    item?.businessObject?.additionalDetails?.plotArea ||
    item?.businessObject?.additionalDetails?.descriptionOfLand?.landArea ||
    item?.businessObject?.additionalDetails?.descriptionOfLand?.plotAreaDoc ||
    item?.businessObject?.additionalDetails?.descriptionOfLand?.plotArea ||
    item?.plotArea ||
    item?.plotInfo?.plotArea ||
    item?.additionalDetails?.plotArea ||
    item?.additionalDetails?.descriptionOfLand?.landArea ||
    item?.additionalDetails?.descriptionOfLand?.plotAreaDoc ||
    item?.additionalDetails?.descriptionOfLand?.plotArea ||
    "-";
  const getSchemeName = (item) =>
    item?.businessObject?.schemeName ||
    item?.businessObject?.additionalDetails?.schemeName ||
    item?.businessObject?.additionalDetails?.descriptionOfLand?.schemeName ||
    item?.businessObject?.descriptionOfLand?.schemeName ||
    item?.schemeName ||
    item?.additionalDetails?.schemeName ||
    item?.additionalDetails?.descriptionOfLand?.schemeName ||
    item?.descriptionOfLand?.schemeName ||
    "-";
  const getPlotNo = (item) =>
    item?.businessObject?.plotNo ||
    item?.businessObject?.additionalDetails?.plotNo ||
    item?.businessObject?.additionalDetails?.descriptionOfLand?.plotNo ||
    item?.businessObject?.descriptionOfLand?.plotNo ||
    item?.plotNo ||
    item?.additionalDetails?.plotNo ||
    item?.additionalDetails?.descriptionOfLand?.plotNo ||
    item?.descriptionOfLand?.plotNo ||
    "-";

  function getApprovalLetter(item) {
    const pdfUrl =
      item?.additionalDetails?.approvalCertificateUrl ||
      item?.approvalCertificateUrl ||
      item?.additionalDetails?.approvalLetterUrl ||
      item?.approvalLetterUrl;
    window.open(pdfUrl, "_blank");
  }

  const [filters, setFilters] = useState({
    name: "",
    applicationNo: "",
    status: "",
    serviceType: "",
    proposedActivity: "",
    plotArea: "",
    schemeName: "",
    plotNo: "",
    date: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState([
    "srNo",
    "applicationNo",
    "name",
    "serviceType",
    "proposedActivity",
    "plotArea",
    "schemeName",
    "plotNo",
    "status",
    "applicationDate",
    "approvalLetter",
  ]);
  const allColumns = [
    { id: "srNo", label: "Sr No", filterable: false },
    {
      id: "applicationNo",
      label: "Application No.",
      filterable: true,
      // render: (item) => item?.additionalDetails?.applicationNo || "-",

      render: (item) => (
        <strong
          onClick={(e) => {
            handleTakeAction(item?.additionalDetails);
          }}
          style={{ color: "blue", textDecoration: "none", cursor: "pointer" }}
        >
          {item?.additionalDetails?.applicationNo || "-"}
        </strong>
      ),
    },
    {
      id: "name",
      label: "Name",
      filterable: true,
      render: (item) => {
        console.log("123456", item);
        return item?.additionalDetails?.landInfo?.owners?.[0]?.name || "-";
      },
    },
    {
      id: "serviceType",
      label: "Service Type",
      filterable: true,
      render: (item) => t(`${item?.additionalDetails?.applicationType}`) || "-",
    },
    {
      id: "proposedActivity",
      label: "Proposed Activity",
      filterable: true,
      render: (item) => getProposedActivity(item),
    },
    {
      id: "plotArea",
      label: "Plot Area",
      filterable: true,
      render: (item) => getPlotArea(item),
    },
    {
      id: "schemeName",
      label: "Scheme Name",
      filterable: true,
      render: (item) => getSchemeName(item),
    },
    {
      id: "plotNo",
      label: "Plot No",
      filterable: true,
      render: (item) => getPlotNo(item),
    },
    {
      id: "status",
      label: "Status",
      filterable: true,
      sortable: true,
      render: (item) => t(`WF_BPA_MAP_${item?.status}`) || "-",
    },
    {
      id: "applicationDate",
      label: "Date",
      filterable: false,
      sortable: true,
      render: (item) => convertEpochToDateDMY(item?.additionalDetails?.auditDetails?.createdTime) || "-",
    },
    {
      id: "approvalLetter",
      label: "Approval Certificate",
      filterable: false,
      sortable: false,
      render: (item) => (
        <td className="td-approval">
          {(item?.status === "APPROVED" || item?.status === "APPLY_FOR_DSC" || item?.status === "APPROVED_JE") &&
            (item?.additionalDetails?.approvalCertificateUrl ||
              item?.approvalCertificateUrl ||
              item?.additionalDetails?.approvalLetterUrl ||
              item?.approvalLetterUrl) && (
              <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getApprovalLetter(item)}>
                <span>View</span>
              </Button>
            )}
        </td>
      ),
      width: "10%",
    },
  ];
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const columns = allColumns.filter((col) => selectedColumns.includes(col.id));

  const closeModal2 = (item) => {
    console.log("item2222", item);
    if (item?.applicationType === "FORM_LANDUSE") {
      setIdData(item?.applicationNo);
      setFormType("formLandUse");
      if (item?.applicationNo != null) {
        setSmShow(true);
      } else {
        console.log("Application Number Null ");
      }
    } else if (item?.applicationType === "FORM_MAP") {
      setIdData(item?.applicationNo);
      setFormType("form12");
      if (item?.applicationNo != null) {
        setSmShowMs(true);
      } else {
        console.log("Application Number Null ");
      }
    } else if (item?.serviceType === "FORM_26") {
      setIdData(item?.applicationNumber);
      setFormType("form26");
      if (item?.applicationNumber != null) {
        setSmShow(true);
      } else {
        console.log("Application Number Null ");
      }
    } else if (item?.applicationType === "FORM_PURCHASABLE_FAR") {
      setIdData(item?.applicationNo);
      setFormType("formFAR");
      if (item?.applicationNo != null) {
        setSmShowFAR(true);
      } else {
        console.log("Application Number Null ");
      }
    } else {
      console.log("all");
    }

    // anchorEl(false);
  };
  const handleGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value,
    });
    setPage(0);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const handleOpenColumnFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };
  // Handle clear filter
  const handleClearFilter = (property) => {
    setFilters({
      ...filters,
      [property]: "",
    });
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      // Don't allow deselecting all columns - at least one must remain
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const getFilteredAndSortedData = () => {
    let filteredData = ApplicationData || [];

    // Apply global search first
    if (globalSearch) {
      filteredData = filteredData?.filter(({ additionalDetails, status }) => {
        const item = { additionalDetails, status };
        return (
          matchesSearch(additionalDetails?.landInfo?.owners?.[0]?.name, globalSearch) ||
          matchesSearch(additionalDetails?.applicationNo, globalSearch) ||
          matchesSearch(t(`${additionalDetails?.applicationType}`), globalSearch) || // FIX: use translated service type
          matchesSearch(t(`WF_BPA_MAP_${status}`), globalSearch) || // FIX: use translated status
          matchesSearch(convertEpochToDateDMY(additionalDetails?.auditDetails?.createdTime), globalSearch) ||
          matchesSearch(getProposedActivity(item), globalSearch) ||
          matchesSearch(getPlotArea(item), globalSearch) ||
          matchesSearch(getSchemeName(item), globalSearch) ||
          matchesSearch(getPlotNo(item), globalSearch)
        );
      });
    }

    // Apply column filters
    if (filters.name) {
      filteredData = filteredData.filter(({ additionalDetails }) => matchesSearch(additionalDetails?.landInfo?.owners?.[0]?.name, filters.name));
    }

    if (filters.applicationNo) {
      filteredData = filteredData.filter(({ additionalDetails }) => matchesSearch(additionalDetails?.applicationNo, filters.applicationNo));
    }

    if (filters.proposedActivity) {
      filteredData = filteredData.filter((item) => matchesSearch(getProposedActivity(item), filters.proposedActivity));
    }

    if (filters.plotArea) {
      filteredData = filteredData.filter((item) => matchesSearch(getPlotArea(item), filters.plotArea));
    }

    if (filters.schemeName) {
      filteredData = filteredData.filter((item) => matchesSearch(getSchemeName(item), filters.schemeName));
    }

    if (filters.plotNo) {
      filteredData = filteredData.filter((item) => matchesSearch(getPlotNo(item), filters.plotNo));
    }

    // FIX: Use translated value for serviceType filter
    if (filters.serviceType) {
      filteredData = filteredData.filter(({ additionalDetails }) => matchesSearch(t(`${additionalDetails?.applicationType}`), filters.serviceType));
    }

    // FIX: Use translated value for status filter
    if (filters.status) {
      filteredData = filteredData.filter(({ status }) => matchesSearch(t(`WF_BPA_MAP_${status}`), filters.status));
    }

    // Apply sorting
    filteredData.sort((a, b) => {
      let comparison = 0;
      const aValue =
        orderBy === "applicationDate"
          ? a?.auditDetails?.createdTime
          : orderBy === "applicationNo"
          ? a?.applicationNo
          : orderBy === "status"
          ? a?.status
          : "";

      const bValue =
        orderBy === "applicationDate"
          ? b?.auditDetails?.createdTime
          : orderBy === "applicationNo"
          ? b?.applicationNo
          : orderBy === "status"
          ? b?.status
          : "";

      if (aValue > bValue) {
        comparison = 1;
      } else if (aValue < bValue) {
        comparison = -1;
      }

      return order === "desc" ? -comparison : comparison;
    });

    return filteredData;
  };
  const filteredAndSortedData = getFilteredAndSortedData();
  const paginatedData = filteredAndSortedData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleExcelDownload = () => {
    // Export filtered items with ALL columns
    const exportData = filteredAndSortedData?.map((app, idx) => {
      const row = {};
      allColumns.forEach((col) => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });

    Digit.Download.Excel(exportData, "Exported Data");
  };

  if (isLoading) return <Loader />;

  return (
    <React.Fragment>
      <TableContainer className="table-container">
        <div className="emp-global-search">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={handleOpenColumnFilter}
              size="small"
              sx={{
                height: "27px",
                fontSize: "12px",
                borderColor: "rgb(31, 74, 124)",
                color: "rgb(31, 74, 124)",
              }}
            >
              {t("FASTPAS.GLOBAL.FILTERS.TEXT")}({selectedColumns.length}/{allColumns.length})
            </Button>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search here..."
              value={globalSearch}
              onChange={(e) => handleGlobalSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ background: "#2A3F54", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                  </InputAdornment>
                ),
                endAdornment: globalSearch && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => handleGlobalSearch("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                padding: "0px",
                height: "25px", // sets outer height
                "& .MuiInputBase-root": {
                  height: "27px",
                  padding: "0px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgb(31, 74, 124)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "0", // top/bottom padding controls the internal height
                  fontSize: "12px",
                },
              }}
            />
            <button
              onClick={handleExcelDownload}
              title="Export to Excel"
              style={{
                height: "35px",
                padding: "5px 0px",
                marginRight: "8px",
              }}
              disabled={filteredAndSortedData?.length === 0}
            >
              <FaFileExcel style={{ fontSize: "20px", color: "rgb(85 108 214)" }} />
            </button>
          </div>
        </div>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseColumnFilter}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className="select-column-popover">
            <Typography variant="subtitle2" gutterBottom>
              Select Columns to Display
            </Typography>
            {allColumns.map((column) => (
              <div key={column.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ padding: "0px" }}
                      checked={selectedColumns.includes(column.id)}
                      onChange={() => handleColumnToggle(column.id)}
                      disabled={column.id === "srNo" && selectedColumns.length === 1}
                    />
                  }
                  sx={{ margin: "0px" }}
                  label={column.label}
                />
              </div>
            ))}
          </div>
        </Popover>
        <Table className="application-table">
          <thead>
            <tr>
              {/* <th className="fit-table-head">Sr/n</th>
              <th className="fit-table-head">Application No</th>
              {!(hasAuthorizedRoles || authorizedOfficer) && <th className="fit-table-head">FASTPAS ID</th>}
              <th className="fit-table-head">Owner Name</th>
              <th className="fit-table-head">Service Type</th>
              <th className="fit-table-head">Status</th>
              <th className="fit-table-head">Date of Application</th> */}
              {columns.map((column) => (
                <th display="flex" alignItems="center">
                  {column.label}
                  {column.sortable && (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleSort(column.id)}
                      sx={{
                        color: "white !important", // Force white text
                        "& .MuiTableSortLabel-icon": {
                          opacity: "1 !important", // Force icon to always be visible
                          color: "white !important", // Force white icon
                        },
                        "&:hover": {
                          color: "white !important", // Ensure hover doesn't change color
                        },
                      }}
                      // Force the icon to render even when inactive
                      IconComponent={(props) => (
                        <ArrowDownward
                          {...props}
                          sx={{
                            color: "white !important",
                            opacity: 1, // Ensure icon is always visible
                          }}
                        />
                      )}
                    />
                  )}
                </th>
              ))}
            </tr>
            <tr>
              {columns?.map((column) => (
                <td key={column.id}>
                  {column.filterable && (
                    <TextField
                      variant="standard"
                      size="small"
                      value={filters[column.id] || ""}
                      onChange={(e) => handleFilterChange(column.id, e.target.value)}
                      InputProps={{
                        // startAdornment: (
                        //   <InputAdornment position="start">
                        //     <SearchIcon fontSize="small" />
                        //   </InputAdornment>
                        // ),
                        endAdornment: filters[column.id] && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => handleClearFilter(column.id)} sx={{ color: "white" }}>
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiInput-input": {
                          color: "black !important",
                          fontSize: "0.75rem",
                        },
                        width: "100%",
                      }}
                    />
                  )}
                </td>
              ))}
            </tr>
          </thead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No records found
                </TableCell>
              </TableRow>
            ) : (
              paginatedData.map((item, index) => (
                <StyledTableRow hover key={index}>
                  {columns.map((column) => (
                    <TableCell key={`${index}-${column.id}`}>{column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item)}</TableCell>
                  ))}
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={ApplicationData?.length || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
      {/* Modals for each form */}
      <DialogContentModal title="Application Details" dataOpen={smShow} onClose={() => setSmShow(false)}>
        <TakeActionItem id={idData} formType={formType} />
      </DialogContentModal>

      <DialogContentModal title="Application Details" dataOpen={SmShowFAR} onClose={() => setSmShowFAR(false)}>
        <Summary id={idData} />
      </DialogContentModal>

      <DialogContentModal title="Application Details" dataOpen={smShowMs} onClose={() => setSmShowMs(false)}>
        <SearchSummary id={idData} />{" "}
      </DialogContentModal>
    </React.Fragment>
  );
};
export default InboxTable;
